import { render, staticRenderFns } from "./PlusMinus.vue?vue&type=template&id=12a5bf34&"
import script from "./PlusMinus.vue?vue&type=script&lang=js&"
export * from "./PlusMinus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/m1292/Documents/develop/laravel/cure-naruhodoga/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12a5bf34')) {
      api.createRecord('12a5bf34', component.options)
    } else {
      api.reload('12a5bf34', component.options)
    }
    module.hot.accept("./PlusMinus.vue?vue&type=template&id=12a5bf34&", function () {
      api.rerender('12a5bf34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/commons/PlusMinus.vue"
export default component.exports